import React from 'react';

import { useSelector } from '@datagrid/state';

import { AuthProvider as SharedAuthProvider } from '@tf/shared';

import { configStore } from '@/core/stores';

export const AuthProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const config = useSelector(() => configStore.get());

	return (
		<SharedAuthProvider publishableKey={config.auth.clerk_publishable_key}>
			{children}
		</SharedAuthProvider>
	);
};
